export const EMAIL_TAKEN_CREATE_USER = 913;

export const EMAIL_TAKEN_CREATE_USER_PATIENT = 409;
export const EXTERNAL_ID_TAKEN = 912;
export const INVALID_PHONE_NUMBER = 422;
export const INVALID_ADDITION_PHONE_NUMBER = 123456;

export const USER_PRIMARY_KEY_DUPLICATION_ERROR = 939;
export const USER_SECONDARY_KEYS_DUPLICATION_ERROR = 940;

export const apiErrorMessagesMap = {
  [EMAIL_TAKEN_CREATE_USER]: {
    id: 'MyAccount.Details.Edit.EmailAlreadyUsedError',
    defaultMessage: '** Email already used by another user',
    field: 'email',
    step: 2,
  },
  [EMAIL_TAKEN_CREATE_USER_PATIENT]: {
    id: 'MyAccount.Details.Edit.EmailAlreadyUsedError',
    defaultMessage: '** Email already used by another user',
    field: 'email',
    step: 3,
  },
  [EXTERNAL_ID_TAKEN]: {
    id: 'Users.CeateUser.UserID.UserExistsError',
    defaultMessage: '** User ID already exists',
    field: 'externalId',
  },
  [INVALID_PHONE_NUMBER]: {
    id: 'MyAccount.Details.Edit.InvalidPhoneNoFormatError',
    defaultMessage: '** Invalid phone number format',
    field: 'phoneNumber',
  },
  [USER_SECONDARY_KEYS_DUPLICATION_ERROR]: {
    id: 'MyAccount.Details.Edit.UserExistsError',
    defaultMessage: '** Another user with such identity fields already exists',
  },
};
